import { ITransactedTypeValue, ITransactedTypeValueItem } from './../interfaces/transacted-type-value.interface';
import { BaseModel, Default } from '@red/data-access';
import { Expose } from 'class-transformer';
export class TransactedTypeValueModel extends BaseModel implements ITransactedTypeValue {
  @Expose()
  cashAdvance!: ITransactedTypeValueItem;

  @Expose()
  discount!: ITransactedTypeValueItem;

  @Expose()
  powerDiscount!: ITransactedTypeValueItem;

  @Expose()
  incentive!: ITransactedTypeValueItem;

  @Expose()
  buyerRebate!: ITransactedTypeValueItem;

}
